/**
 * @typedef {{product: Object, quantity: number, options: number[][]}} ProductItem
 */
(function () {
  const tenantId = '000000';
  const project = 'DREAME-MALL';
  const appSecret = 'P!r6&t8Z2#wX5$qV';
  const appId = 'K2x7Q9p4R8';
  const baseUrl = 'https://eu-store.dreame.tech/dreame-store';
  const api = {
    warranty: "/api/v1/warranty/get-by-sn",
    warrantyList: "/api/v1/warranty/list-by-email",
    // 注册产品
    productRegister: "/api/v1/product-register/create",
    registeredproducts: "/api/v1/product-register/list-register-by-email",
    unregisteredproducts: "/api/v1/product-register/list-unregistered-by-email",
    // 销售渠道
    purchaseChannelList: "/api/v1/purchase-channel/list",
    // 根据sn码获取产品信息
    snProductList: "/api/v1/product/list-product-model-by-sn",
    // 已购买的延保订单
    extendedWarrantyOrders: "/api/v1/order/warranty/list-by-shopfiy-user-id",
    // 激活延保
    activeExtendedWarranty: "/api/v2/warranty/active-extended-warranty",
  }
  /**
   * @param {String} api 
   * @param {RequestInfo} info 
   */
  const request = async (api, data, info) => {
    const body = data;
    // 获取 body 的参数 json
    const bodyString = JSON.stringify(body);
    const timestamp = Date.now();
    const stringSignTemp = bodyString + timestamp + appSecret;
    const sign = CryptoJS.MD5(stringSignTemp).toString();

    return fetch(baseUrl + api, {
      ...{
        method: 'POST',
        body: bodyString,
        headers: {
          tenant_id: tenantId,
          project: project,
          'dreame-api-sign': sign,
          'dreame-api-app-id': appId,
          'dreame-api-timestamp': timestamp.toString(),
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      },
      ...info ?? {}
    }).then((res) => {
      return res.json();
    }).catch((err) => {
      console.error(err);
      throw err;
    });
  }

  window.productRegistrationVue = new Vue({
    el: '.product-registration--warranty',
    delimiters: ['${', '}'],
    data() {
      return {
        warranty: null,
        warrantyLoading: null,
        warrantyList: [],
        warrantyListLoading: null,
        // 'add', 'success', 'failed'
        route: '/',
        // 默认路由，首次进入网页时可能会变化
        defaultRoute: '/',
        routes: {
          default: '/',
          // 单个质保卡
          singleWarrantyCard: '/warranty',
          // 激活延保
          activateExtended: '/activateExtended',
          activateExtendedFailed: '/activateExtendedFailed',
          activateExtendedSuccess: '/activateExtendedSuccess',
        },
        formErrorCode: null,
        // 表单激活延保按钮的 loading
        formActiveLoading: false,
        // 表单激活延保按钮禁用
        formActiveButtonDisabled: false,
        // 延保订单列表
        extendedOrderList: [],
        // 延保订单列表loading
        extendedOrderListLoading: false,
        // 激活延保的表单
        activeExtendedForm: {
          dreame_order_id: null,
          sn: null,
          shopfiy_user_id: window.productRegistration.customer.id.toString(),
          country_code: window.productRegistration.customer.countryCode,
        },
        dateNow: new Date().getTime(),
        lostImage: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTg3IiBoZWlnaHQ9IjE4NyIgdmlld0JveD0iMCAwIDE4NyAxODciIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHJlY3Qgd2lkdGg9IjE4NyIgaGVpZ2h0PSIxODciIHJ4PSI4IiBmaWxsPSIjRjVGNUY1Ij48L3JlY3Q+PHBhdGggZD0iTTc3LjYxMDkgMTE2LjE5M0g2Ni42Njg2TDg2Ljg5NTMgOTUuMDMwM0w5MC4yMTEyIDk3LjU4Nkw4OC43OTAxIDc5LjcxOTdMMTA0LjQ2OSA3MC43MTVMMTA0Ljc3NyA2M0g1OFYxMjNINzYuMzMxOUw3Ny42MTA5IDExNi4xOTNaTTc2LjQ1MDQgNzMuOTYzNEM3Ny43NjMgNzMuOTU4NiA3OS4wNDc1IDc0LjM0NjkgODAuMTQxMiA3NS4wNzg5QzgxLjIzNDkgNzUuODEwOSA4Mi4wODg2IDc2Ljg1MzcgODIuNTk0MSA3OC4wNzUzQzgzLjA5OTcgNzkuMjk3IDgzLjIzNDQgODAuNjQyNCA4Mi45ODEyIDgxLjk0MTNDODIuNzI4IDgzLjI0MDIgODIuMDk4MyA4NC40MzQxIDgxLjE3MTggODUuMzcxOEM4MC4yNDUyIDg2LjMwOTUgNzkuMDYzNiA4Ni45NDg5IDc3Ljc3NjYgODcuMjA4OUM3Ni40ODk1IDg3LjQ2ODkgNzUuMTU0OSA4Ny4zMzc4IDczLjk0MTcgODYuODMyM0M3Mi43Mjg1IDg2LjMyNjkgNzEuNjkxNCA4NS40Njk3IDcwLjk2MTYgODQuMzY5M0M3MC4yMzE5IDgzLjI2OSA2OS44NDIzIDgxLjk3NSA2OS44NDIzIDgwLjY1MTNDNjkuODQyMyA3OC44ODE3IDcwLjUzNzggNzcuMTg0MiA3MS43NzYzIDc1LjkzMDZDNzMuMDE0OSA3NC42NzcxIDc0LjY5NTYgNzMuOTY5NyA3Ni40NTA0IDczLjk2MzRaTTExNS4xNTEgNjNMMTE0LjIyNyA3MC41TDk4LjMzNSA4NS44ODIyTDk3LjQ1ODcgMTAzLjE3NUw5OC42MTkyIDEwNC4wODNMMTExLjIxOSA4OS45MTg4TDEyMi4yNTcgMTAzLjA1NlYxMTYuMTkzSDgyLjY1NThMODEuNTE4OSAxMjNIMTI5LjA1NFY2M0gxMTUuMTUxWiIgZmlsbD0iI0E4QThBOCI+PC9wYXRoPjwvc3ZnPg==',
      }
    },
    computed: {
    },
    beforeMount() {
      this.initData().catch((err) => {
        console.error(err);
        throw err;
      });;
      setInterval(() => {
        this.dateNow = new Date().getTime();
      }, 1000);
    },
    created() {
    },
    mounted() {
      this.$el.classList.remove('vue--loading');
    },
    methods: {
      // 初始化数据
      async initData() {
        const urlParams = new URLSearchParams(window.location.search);
        const sn = urlParams.get('product_sn');
        if (sn) {
          // 展示单个保修卡
          this.defaultRoute = this.routes.singleWarrantyCard;
          this.route = this.routes.singleWarrantyCard;
          await this.getSingleWarranty(sn);
        } else {
          // 展示保修卡列表
          // TODO
          await this.getWarrantyList();
        }
        await this.getExtendedOrderList();
      },
      async getSingleWarranty(sn) {
        const getSn = sn ?? new URLSearchParams(window.location.search).get('product_sn');
        return request(api.warranty, { sn: getSn }).then((res) => {
          console.log(res);
          this.warranty = res.data;
        }).catch((err) => console.error(err));
      },
      async getWarrantyList() {
        this.warrantyListLoading = true;
        return request(api.warrantyList, { email: window.productRegistration.customer.email }).then((res) => {
          console.log(res);
          this.warrantyList = res.data.list;
        }).finally(() => this.warrantyListLoading = false);
      },
      async getExtendedOrderList() {
        return request(api.extendedWarrantyOrders, {
          shopfiy_user_id: window.productRegistration.customer.id.toString(),
          country_code: 'SE',
          email: window.productRegistration.customer.email,
        }).then((res) => {
          console.log(res);
          this.extendedOrderList = res.data.list;
        });
      },
      formatTimestamp(timestamp) {
        const date = new Date(timestamp);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      },
      debounce(fn, wait) {
        let t;
        return (...args) => {
          clearTimeout(t);
          t = setTimeout(() => fn.apply(this, args), wait);
        };
      },
      handleSingleCardReturn() {
        window.location.href = `/pages/product-registration`;
        // window.history.length > 1
        //   ? window.history.back() :
        //   window.location.href = `${window.theme.routes.root_url}pages/product-registration`;
      },
      goPurchase() {
        window.location.href = `/pages/purchase-extended-warranty`;
      },
      handleClickActivateExtendedButton(warranty) {
        this.activeExtendedForm.sn = warranty.sn;
        this.activeExtendedForm.dreame_order_id = null;
        this.route = this.routes.activateExtended;
      },
      handleConfirmActivate() {
        this.formActiveLoading = true;
        this.formErrorCode = null;
        request(api.activeExtendedWarranty, {
          shopfiy_user_id: window.productRegistration.customer.id.toString(),
          country_code: 'SE',
          sn: this.activeExtendedForm.sn,
          dreame_order_id: Number(this.activeExtendedForm.dreame_order_id),
          email: window.productRegistration.customer.email,
        }).then((res) => {
          console.log(res);
          if (!res.success || res.success == "false") {
            this.route = this.routes.activateExtendedFailed;
            this.formErrorCode = res.code;
            return;
          }
          this.route = this.routes.activateExtendedSuccess;
          if (this.defaultRoute = this.routes.singleWarrantyCard) {
            // 更新单个保修卡 
            this.getSingleWarranty();
          } else {
            // 更新保修卡列表 
            this.getWarrantyList();
          }
        }).catch((err) => {
          console.error(err);
          this.formErrorCode = null;
          this.route = this.routes.activateExtendedFailed;
        }).finally(() => this.formActiveLoading = false);
      },
      handleCancelActivate() {
        this.route = this.defaultRoute;
      },
      //激活成功返回
      handleSuccessReturn() {
        this.route = this.routes.default;
        this.getWarrantyList();
        const urlObj = new URL(window.location.href);
        const searchParams = urlObj.searchParams;
        searchParams.delete('product_sn');
        const newUrl = urlObj.toString();
        // window.history.replaceState(null, '', newUrl);
        window.history.pushState(null, '', newUrl);
      },
      handleOnlineCustomerService() {
        document.querySelector('#launcher').contentDocument.querySelector('button').click();
      }
    }
  });
})();
